go-center {
 display: grid;
 width: 100%;
 height: 100%;
 place-items: center;
 &.align-text {
  text-align: center;
 }
}
